[
  {
    "url": "/_next/static/chunks/turbopack-31pe3yd0p9v-l.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3w3pv18cwn0xy.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3pvsyhm4qwapq.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3kb1i4ztda_qz.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3g4-ovj-pjpl0.css",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/3d67hy95_28sq.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2zmcm0jh9et_o.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2ujkaofjrasy8.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2kmzj0hb1jmee.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/2ijofgz7u8_5w.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/21a13k4dx47dq.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1z7gnmxte_2--.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1xbgmas9b134x.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1viw1fvhb5c0m.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1q1enut8ga1qj.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1bq3q9f9p7tnp.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/1_3tqm5th_ne9.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/18l7icl3oksz4.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0xjmnxuvm81-9.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0x1crwlej_ymv.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0gthr0_43bd8_.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0fwioguaet7gq.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/0cz1d0mv5g_q7.js",
    "revision": null
  },
  {
    "url": "/_next/static/chunks/05-c3ty_6dwfk.js",
    "revision": null
  },
  {
    "url": "/_next/static/8m0ha8oU0NqRYOFa5lSTy/_ssgManifest.js",
    "revision": null
  },
  {
    "url": "/_next/static/8m0ha8oU0NqRYOFa5lSTy/_clientMiddlewareManifest.js",
    "revision": null
  },
  {
    "url": "/_next/static/8m0ha8oU0NqRYOFa5lSTy/_buildManifest.js",
    "revision": null
  },
  {
    "url": "/vue-certificate.png",
    "revision": "dd5f158e44f16b630f8aa4baf8a14776"
  },
  {
    "url": "/skriza_logo.svg",
    "revision": "394bfeacf956ec09708be07a84f38e8b"
  },
  {
    "url": "/sitemap.xml",
    "revision": "9fd74da7deba0c45853c7690ed0a7f58"
  },
  {
    "url": "/single_bird.svg",
    "revision": "9280b120498ac03a906ab67e4e6391a8"
  },
  {
    "url": "/robots.txt",
    "revision": "74ba45913512b15820901c65bb8782a7"
  },
  {
    "url": "/manifest.json",
    "revision": "4730cf13c7393d0c720c7faa4b37dc10"
  },
  {
    "url": "/logsysdev.png",
    "revision": "1779a5f352899f93c78612c06ec76b1c"
  },
  {
    "url": "/livalink_logo.svg",
    "revision": "f3492864e48d13d16ab8e9369cc36115"
  },
  {
    "url": "/image.png",
    "revision": "23ee0a439ef599c1d179c46b0c18b35d"
  },
  {
    "url": "/icons8-favicon.gif",
    "revision": "543b02d2cf17195934706117492b3f8c"
  },
  {
    "url": "/go-certificate.png",
    "revision": "e622317c5ea6e1e2d911af96dbd061ec"
  },
  {
    "url": "/darkquiz.svg",
    "revision": "e50f99c7d7e48cd7958799940838eedd"
  },
  {
    "url": "/AI-README.md",
    "revision": "a88f85d43614aa95decd097fc080cb6d"
  },
  {
    "url": "/icons/icon-512x512.png",
    "revision": "543b02d2cf17195934706117492b3f8c"
  },
  {
    "url": "/icons/icon-192x192.png",
    "revision": "543b02d2cf17195934706117492b3f8c"
  },
  {
    "url": "/icons/icon-144x144.png",
    "revision": "543b02d2cf17195934706117492b3f8c"
  },
  {
    "revision": "build-1784539923740",
    "url": "/~offline"
  }
]